import { render, staticRenderFns } from "./PriceOfferModal.vue?vue&type=template&id=1670121e&scoped=true&"
import script from "./PriceOfferModal.vue?vue&type=script&lang=js&"
export * from "./PriceOfferModal.vue?vue&type=script&lang=js&"
import style0 from "./PriceOfferModal.vue?vue&type=style&index=0&id=1670121e&prod&scoped=true&lang=css&"
import style1 from "./PriceOfferModal.vue?vue&type=style&index=1&id=1670121e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1670121e",
  null
  
)

export default component.exports